import React, { Suspense, lazy } from 'react'
import { Routes, Route } from 'react-router-dom'
import VerificationCookies from './Components/verificationCookies/verificationCookies'
import 'bootstrap/dist/css/bootstrap.min.css'
import CartProvider from './Context/CartContext'
import { ProductProvider } from './Context/ProductContext'
import Navigation from './Components/Navigation/navbar'
import Footer from './Components/Footer/footer'
import Spinner from 'react-bootstrap/Spinner'
import './App.css'

// Lazy load route components
const Home = lazy(() => import('./Routes/home'))
const About = lazy(() => import('./Routes/about'))
const Shop = lazy(() => import('./Routes/shop'))
const Product = lazy(() => import('./Routes/product'))
const Checkout = lazy(() => import('./Routes/checkout'))
const Success = lazy(() => import('./Routes/success'))

// Loading component for Suspense fallback
const LoadingSpinner = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
    <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  </div>
)

export default function App() {
  return (
    <ProductProvider>
      <CartProvider>
        <VerificationCookies />
        <div className="app">
          <Navigation />
          <div className="body-container">
            <Suspense fallback={<LoadingSpinner />}>
              <Routes>
                <Route exact path="/" element={<Home />} />
                <Route path="/About" element={<About />} />
                <Route path="/Shop" element={<Shop />} />
                <Route path="/Shop/:id" element={<Product />} />
                <Route path="/Checkout" element={<Checkout />} />
                <Route path="/Checkout/Success" element={<Success />} />
              </Routes>
            </Suspense>
          </div>
          <Footer />
        </div>
      </CartProvider>
    </ProductProvider>
  )
}
